import { useState } from "react"
import Flex from "./utils/Flex"
import TWInput from './utils/TWInput/TWInput'
import TWButton from './utils/TWButton/TWButton'
import Icon from "./utils/Icon"
import IconClose from "./icons/IconClose"

const CreateCampaign = ({ onCancel }) => {
	const [subs, setSubs] = useState([0, 0])
	const onSubmit = (e) => {
		e.preventDefault()
		console.log('onSubmit')
	}
	return (
		<div className="p-2 lg:p-16 relative">
			<Icon onClick={() => onCancel()} className='absolute top-4 right-4 w-5 h-5 cursor-pointer'>
				<IconClose />
			</Icon>
			<h4 className="text-xl lg:text-2xl xl:text-3xl font-bold">
				Promotional Sales
			</h4>
			<p className="text-sm xl:text-lg text-gray-300">
				Enter the amount you wish to charge for the promotional sale and how
				many subscriptions you will allow the discount for.
			</p>
			<form onSubmit={onSubmit} className="mt-4 lg:mt-8">
				<TWInput
					dark
					hint="$5.00"
					label="1 Month"
					name="one-month"
					value={subs[0]}
					labelClass="w-28"
					className="mb-1 md:mb-6"
					inputClass="w-full"
					contentClass="w-full"
					onChange={e => setSubs(s => [s[0], e.target.value])}
				/>
				<TWInput
					dark
					hint="$5.00"
					name="three-month"
					label="3 Months"
					labelClass="w-28"
					className="mb-1 md:mb-6"
					inputClass="w-full"
					contentClass="w-full"
					value={subs[1]}
					onChange={e => setSubs(s => [e.target.value, s[1]])}
				/>
				<div className="text-center text-gray-300">
					The number of subscriptions available for sale.
				</div>
				<Flex justify-between className="mt-10 space-x-12">
					<TWButton size="sm" color="primary">
						Start Campaign
					</TWButton>
					<TWButton size="sm" className="px-12" onClick={() => onCancel()}>
						Cancel
					</TWButton>
				</Flex>
			</form >
		</div >
	)
}

export default CreateCampaign